export default "/_next/static/images/product--inbox-b5b7a8ae9ec0ccf28b99663c2e3dce8c.svg";